import { Routing } from './Routing.tsx';

export function App() {
  return (
    <>
      <Routing />
    </>
  );
}
